import Box from "@mui/material/Box";

type AudiogramAnnotationBarProps = {
  annotation?: string | null;
};

export default function AudiogramAnnotationBar({
  annotation
}: AudiogramAnnotationBarProps) {
  if (!annotation) return null;

  return (
    <Box
      data-testid="audiogram-annotation-bar"
      sx={{
        width: "100%",
        bgcolor: "#000000",
        color: "#FFFFFF",
        px: 1.5,
        py: 0.5,
        fontWeight: "fontWeightBold",
        fontSize: "0.875rem",
        whiteSpace: "pre-wrap",
        wordBreak: "break-word"
      }}
    >
      {annotation}
    </Box>
  );
}
